var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "screen-container",
        _vm.collspan ? "isCollspan" : "",
        _vm.isAllScreen ? "allScreen" : "noScreen",
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "screen-center-container",
          on: { mousemove: _vm.onMove },
        },
        [
          !_vm.loadingConfig.mapLoading
            ? [
                _vm._l(_vm.ringPositionArray, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: index,
                        class: ["data-ring-animate", "d" + index],
                        style: {
                          right: item[0] / 18 + "%",
                          bottom: (item[1] + 200) / 18 + "%",
                          animationDelay: item[2],
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "ring-dot",
                          style: { animationDelay: item[2] },
                        }),
                      ]
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "screen-box" },
            [
              _c("div", { staticClass: "total-container" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingConfig.monthLoading,
                        expression: "loadingConfig.monthLoading",
                      },
                    ],
                    staticClass: "total-wrap",
                  },
                  [
                    _c("div", { staticClass: "data-wrap" }, [
                      _c("div", { staticClass: "data-item flmin" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(_vm._s(_vm.$t("screen-board::月累计成交额"))),
                        ]),
                        _c("div", { staticClass: "number" }, [
                          _vm.monthData.grandTotalUsdMonth
                            ? _c("span", [
                                _vm._v(
                                  "$" + _vm._s(_vm.monthData.grandTotalUsdMonth)
                                ),
                              ])
                            : _c("span", [
                                _c("span", [_vm._v("$")]),
                                _vm._v(" 0.00 "),
                              ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "data-item" }, [
                        _c(
                          "div",
                          { staticClass: "item-title" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("screen-board::月环比")) + " "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "screen-board::mouth_tooltip"
                                  ),
                                  disabled: _vm.tipDisabled,
                                  effect: "light",
                                  placement: "bottom",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "icona-01wenhao3 iconfont",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            class: [
                              "number",
                              _vm.monthData.grandTotalUsdMonthRatio > 0
                                ? "istop"
                                : _vm.monthData.grandTotalUsdMonthRatio < 0
                                ? "isdown"
                                : "",
                            ],
                          },
                          [
                            _vm.monthData.grandTotalUsdMonthRatio
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      Math.abs(
                                        _vm.monthData.grandTotalUsdMonthRatio
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", [_vm._v("0.00")]),
                            _c("span", { staticClass: "pz" }, [_vm._v("%")]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "data-item flmin" }, [
                        _c(
                          "div",
                          { staticClass: "item-title" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("screen-board::月目标达成率")) +
                                " "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  disabled: _vm.tipDisabled,
                                  effect: "light",
                                  placement: "bottom",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "big-screen-tip-content",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "screen-board::mouth_target_tooltip"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.routeAtive(
                                              "/operate-config?type=target"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("screen-board::目标配置")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "screen-board::mouth_target_tooltip_end"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "iconfont icona-01wenhao3",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "number" }, [
                          _vm.monthData.monthTargetAchievementRate
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.monthData.monthTargetAchievementRate
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v("0.00")]),
                          _c("span", { staticClass: "pz" }, [_vm._v("%")]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingConfig.dayLoading,
                        expression: "loadingConfig.dayLoading",
                      },
                    ],
                    staticClass: "total-wrap center-content",
                  },
                  [
                    _vm.dayData.grandTotalUsd
                      ? _c(
                          "div",
                          { staticClass: "total-number" },
                          [
                            _c("ScrollNumber", {
                              attrs: {
                                height: _vm.numberHeight,
                                inHeight: _vm.inHeight,
                                itemStyle: _vm.numberStyle,
                                value: "$" + String(_vm.dayData.grandTotalUsd),
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "total-number" },
                          [
                            _c("ScrollNumber", {
                              attrs: {
                                height: _vm.numberHeight,
                                inHeight: _vm.inHeight,
                                itemStyle: _vm.numberStyle,
                                value: "$0.00",
                              },
                            }),
                          ],
                          1
                        ),
                    _c("div", { staticClass: "total-box" }, [
                      _c(
                        "span",
                        { staticClass: "t-item" },
                        [
                          _c("span", [_vm._v("ROI")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                disabled: _vm.tipDisabled,
                                effect: "light",
                                placement: "bottom",
                              },
                            },
                            [
                              _vm.sourceType == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "big-screen-tip-content",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("screen-board::roi_tooltip")
                                          ) +
                                          " "
                                      ),
                                      _c("br"),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.routeAtive(
                                                "/stores/shop-site"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "screen-board::绑定广告账号"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::roi_tooltip_end"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "big-screen-tip-content",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "screen-board::roi_tooltip_erp"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                              _c("i", {
                                staticClass: "icona-01wenhao3 iconfont",
                              }),
                            ]
                          ),
                          _c("span", [
                            _vm.dayData.roi
                              ? _c("span", [_vm._v(_vm._s(_vm.dayData.roi))])
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "t-item" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("screen-board::毛利率"))),
                          ]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                disabled: _vm.tipDisabled,
                                effect: "light",
                                placement: "bottom",
                              },
                            },
                            [
                              _vm.sourceType == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "big-screen-tip-content",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("screen-board::rate_tooltip")
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.routeAtive(
                                                "/stores/shop-site"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "screen-board::绑定广告账号"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::rate_tooltip_center_fee"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.routeAtive(
                                                "/products-info"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "screen-board::导入商品信息"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::rate_tooltip_center"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.routeAtive(
                                                "/operate-config"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("screen-board::经营配置")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::rate_tooltip_end"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "big-screen-tip-content",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::rate_tooltip_erp"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.routeAtive(
                                                "/operate-config"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("screen-board::经营配置")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "screen-board::rate_tooltip_end"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                              _c("i", {
                                staticClass: "icona-01wenhao3 iconfont",
                              }),
                            ]
                          ),
                          _c("span", [
                            _vm.dayData.profitRate
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.dayData.profitRate) + "%"),
                                ])
                              : _c("span", [_vm._v("0.00%")]),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingConfig.monthLoading,
                        expression: "loadingConfig.monthLoading",
                      },
                    ],
                    staticClass: "total-wrap",
                    staticStyle: { width: "35%" },
                  },
                  [
                    _c("div", { staticClass: "data-wrap" }, [
                      _c("div", { staticClass: "data-item" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(_vm._s(_vm.$t("screen-board::日环比"))),
                        ]),
                        _c(
                          "div",
                          {
                            class: [
                              "number",
                              _vm.dayData.grandTotalUsdRatio > 0
                                ? "istop"
                                : _vm.dayData.grandTotalUsdRatio < 0
                                ? "isdown"
                                : "",
                            ],
                          },
                          [
                            _vm.dayData.grandTotalUsdRatio
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      Math.abs(_vm.dayData.grandTotalUsdRatio)
                                    )
                                  ),
                                ])
                              : _c("span", [_vm._v("0.00")]),
                            _c("span", { staticClass: "pz" }, [_vm._v("%")]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "data-item" }, [
                        _c(
                          "div",
                          { staticClass: "item-title" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("screen-board::客单价")) + " "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  disabled: _vm.tipDisabled,
                                  effect: "light",
                                  placement: "bottom",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "big-screen-tip-content",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("screen-board::custom_price_tip")
                                      )
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "iconfont icona-01wenhao3",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { class: ["number"] }, [
                          _vm.dayData.customerPrice
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.dayData.customerPrice)),
                              ])
                            : _c("span", [_vm._v("0.00")]),
                        ]),
                      ]),
                      _c("div", { staticClass: "data-item small-card-item" }, [
                        _c(
                          "div",
                          { staticClass: "item-title" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("screen-board::连带率")) + " "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  disabled: _vm.tipDisabled,
                                  effect: "light",
                                  placement: "bottom",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "big-screen-tip-content",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("screen-board::more_rate_tip")
                                      )
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "iconfont icona-01wenhao3",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "number" }, [
                          _vm.dayData.associatedPurchaseRate
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.dayData.associatedPurchaseRate)
                                ),
                              ])
                            : _c("span", [_vm._v("0.00")]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._m(0),
              _c("div", { staticClass: "main-content-box" }, [
                _c("div", { staticClass: "product-box" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingConfig.productLoading,
                          expression: "loadingConfig.productLoading",
                        },
                      ],
                      staticClass: "goods-wrap",
                    },
                    [
                      _c("div", { staticClass: "goods-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("screen-board::店铺日成交排行榜")) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.routeAtive("/day-report", _vm.params)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("screen-board::more")) + " "
                            ),
                            _c("i", {
                              staticClass: "iconfont icona-06xiala left-icon",
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "goods-list" },
                        [
                          _c("ScrollsBar", { ref: "scroll1" }, [
                            _c("div", { staticClass: "table-padding" }, [
                              _c("table", { staticClass: "table-box" }, [
                                _c("thead", [
                                  _c("tr", [
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::店铺"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::日成交额"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::日环比"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::月成交额"))
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm.products.length
                                  ? _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.products,
                                        function (item, index) {
                                          return _c(
                                            "tr",
                                            {
                                              key: index,
                                              staticClass: "goods-item",
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "gd-title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "dot-icon-span",
                                                    },
                                                    [
                                                      item.rank == 1
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d0.png"),
                                                            },
                                                          })
                                                        : item.rank == 2
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d1.png"),
                                                            },
                                                          })
                                                        : item.rank == 3
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d2.png"),
                                                            },
                                                          })
                                                        : _c("span", {}, [
                                                            _vm._v(
                                                              _vm._s(
                                                                Number(
                                                                  item.rank
                                                                ).toFixed(0)
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "one-line title",
                                                      attrs: {
                                                        title: item.brandName,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.brandName)
                                                      ),
                                                    ]
                                                  ),
                                                  item.rankDiff > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-t dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-shangsheng",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : item.rankDiff < 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-d dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-xiajiang",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        { staticClass: "dot" },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "dot-span-tip",
                                                            },
                                                            [_vm._v("-")]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _c("td", [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      _vm.$dataCheck(
                                                        _vm.formatNumberMix(
                                                          item.grandTotalUsd,
                                                          2,
                                                          "",
                                                          ""
                                                        )
                                                      )
                                                    )
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                { staticClass: "td-rate" },
                                                [
                                                  item.grandTotalUsdRatio > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-t dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-shangsheng",
                                                          }),
                                                        ]
                                                      )
                                                    : item.grandTotalUsdRatio <
                                                      0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-d dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-xiajiang",
                                                          }),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        { staticClass: "dot" },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "dot-span-tip",
                                                            },
                                                            [_vm._v("-")]
                                                          ),
                                                        ]
                                                      ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          _vm.formatNumberMix(
                                                            Math.abs(
                                                              item.grandTotalUsdRatio
                                                            ),
                                                            2,
                                                            "",
                                                            "%"
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("td", [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      _vm.$dataCheck(
                                                        _vm.formatNumberMix(
                                                          item.grandTotalUsdMonth,
                                                          2,
                                                          "",
                                                          ""
                                                        )
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "empty-td",
                                            attrs: { colspan: "4" },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "empty-img",
                                              attrs: {
                                                src: require("@/assets/images/empty1.png"),
                                              },
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "empty-content" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "screen-board::shop_empty"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "empty-a",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$store.commit(
                                                          "setShopVisiable",
                                                          { visiable: true }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "screen-board::shop_empty_tip"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingConfig.spuLoading,
                          expression: "loadingConfig.spuLoading",
                        },
                      ],
                      staticClass: "goods-wrap last-margin",
                    },
                    [
                      _c("div", { staticClass: "goods-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("screen-board::SPU日销量排行榜")) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.routeAtive("/day-report", _vm.params)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("screen-board::more")) + " "
                            ),
                            _c("i", {
                              staticClass: "iconfont icona-06xiala left-icon",
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "goods-list" },
                        [
                          _c("ScrollsBar", { ref: "scroll2" }, [
                            _c("div", { staticClass: "table-padding" }, [
                              _c("table", { staticClass: "table-box" }, [
                                _c("thead", [
                                  _c("tr", [
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::SPU"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::日销量"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::日环比"))
                                      ),
                                    ]),
                                    _c("td", { staticClass: "th" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("screen-board::月成交额"))
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm.spuDatas.length
                                  ? _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.spuDatas,
                                        function (item, index) {
                                          return _c(
                                            "tr",
                                            {
                                              key: index,
                                              staticClass: "goods-item",
                                            },
                                            [
                                              _c(
                                                "td",
                                                { staticClass: "gd-title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "dot-icon-span",
                                                    },
                                                    [
                                                      item.rank == 1
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d0.png"),
                                                            },
                                                          })
                                                        : item.rank == 2
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d1.png"),
                                                            },
                                                          })
                                                        : item.rank == 3
                                                        ? _c("img", {
                                                            staticClass:
                                                              "dot-icon",
                                                            attrs: {
                                                              src: require("@/assets/images/d2.png"),
                                                            },
                                                          })
                                                        : _c("span", {}, [
                                                            _vm._v(
                                                              _vm._s(
                                                                Number(
                                                                  item.rank
                                                                ).toFixed(0)
                                                              )
                                                            ),
                                                          ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "right",
                                                            "popper-class":
                                                              "big-screen-tip-img",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _c("zImg", {
                                                                staticClass:
                                                                  "img-size",
                                                                attrs: {
                                                                  src: item.spuImage,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c("zImg", {
                                                            staticClass:
                                                              "img-size",
                                                            attrs: {
                                                              src: item.spuImage,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "one-line fx",
                                                          attrs: {
                                                            title: item.spuName,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.spuName)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  item.rankDiff > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-t dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-shangsheng",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : item.rankDiff < 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-d dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-xiajiang",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        { staticClass: "dot" },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "dot-span-tip",
                                                            },
                                                            [_vm._v("-")]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Math.abs(
                                                                  item.rankDiff
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      _vm.formatNumberMix(
                                                        item.spuNum,
                                                        0,
                                                        "",
                                                        ""
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                { staticClass: "td-rate" },
                                                [
                                                  item.spuNumRatio > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-t dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-shangsheng",
                                                          }),
                                                        ]
                                                      )
                                                    : item.spuNumRatio < 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "dot-d dot",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont iconic-xiajiang",
                                                          }),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        { staticClass: "dot" },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "dot-span-tip",
                                                            },
                                                            [_vm._v("-")]
                                                          ),
                                                        ]
                                                      ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          _vm.formatNumberMix(
                                                            Math.abs(
                                                              item.spuNumRatio
                                                            ),
                                                            2,
                                                            "",
                                                            "%"
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("td", [
                                                _vm._v(
                                                  "$" +
                                                    _vm._s(
                                                      _vm.$dataCheck(
                                                        _vm.formatNumberMix(
                                                          item.grandTotalUsdMonth,
                                                          2,
                                                          "",
                                                          ""
                                                        )
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "empty-td",
                                            attrs: { colspan: "4" },
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "empty-img",
                                              attrs: {
                                                src: require("@/assets/images/empty2.png"),
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "empty-content empty-tip-content-info",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "screen-board::noshop_empty_tip"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      "append-to-body": false,
                                                      popperOptions:
                                                        _vm.popperEmptyOptions,
                                                      effect: "light",
                                                      placement: "bottom",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "big-screen-tip-content",
                                                        attrs: {
                                                          slot: "content",
                                                        },
                                                        slot: "content",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "t-item",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "screen-board::noshop_empty_tip_1"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "t-item",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "screen-board::noshop_empty_tip_2"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "t-item",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "screen-board::noshop_empty_tip_3"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icona-01wenhao3",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("Map", {
                ref: "mapContainer",
                attrs: { config: _vm.mapConfig },
                on: { changeZone: _vm.changeZone, inited: _vm.onInitMap },
              }),
              _c("div", { staticClass: "update-time-wrap" }, [
                _c(
                  "div",
                  { staticClass: "update-time-position" },
                  [
                    _c(
                      "span",
                      { staticClass: "mr-8" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("screen-board::数据更新")) + " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              disabled: _vm.tipDisabled,
                              effect: "light",
                              placement: "bottom",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "big-screen-tip-content",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c("div", { staticClass: "t-item" }, [
                                  _vm._v("更新频率：10分钟"),
                                ]),
                              ]
                            ),
                            _c("i", {
                              staticClass: "iconfont icona-01wenhao3",
                            }),
                          ]
                        ),
                        _vm._v(" ：" + _vm._s(_vm.updateTime) + " "),
                      ],
                      1
                    ),
                    _c("i", { staticClass: "iconfont iconCalendar date-icon" }),
                    _c("el-date-picker", {
                      attrs: {
                        clearable: false,
                        "picker-options": _vm.pickerOptions,
                        "popper-class": "date-input-cell",
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      on: { change: _vm.timeChange },
                      model: {
                        value: _vm.params.dt,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "dt", $$v)
                        },
                        expression: "params.dt",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              !_vm.moveChecked
                ? _c(
                    "handleIcon",
                    {
                      attrs: { isAllScreen: _vm.isAllScreen },
                      on: {
                        allScreen: function ($event) {
                          return _vm.toggleAllScreenFull(!_vm.isAllScreen)
                        },
                      },
                    },
                    [
                      _c("template", { slot: "menu" }, [
                        _c("li", { on: { click: _vm.getScreenInfo } }, [
                          _c("div", { staticClass: "icon" }, [
                            _c("i", { staticClass: "iconfont iconRefresh" }),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("dashboard-bi::default-board::refresh")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-box" }, [
      _c("div", { staticClass: "line-content" }, [
        _c("div", { staticClass: "wrap" }, [
          _c("div", { staticClass: "light-move-right" }, [
            _c("img", {
              staticClass: "light-icon",
              attrs: { src: require("@/assets/images/light.png") },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }